import React, { Component } from "react";
import { toast } from "react-toastify";
import Information from "../../components/Toastify/Information";
import { FormattedMessage } from "react-intl";
import { TOAST_CONFIG } from "../../Utilities/toastConfig";

class StudentCoursesList extends Component {
  notify = () =>
    toast.error(
      <FormattedMessage id="Tostify.Message.UpdateDone" />,
      TOAST_CONFIG
    );

  render() {
    return (
      <div className="animated fadeIn">
        StudentCoursesList
        <Information notify={this.notify} />
      </div>
    );
  }
}

export default StudentCoursesList;
